import { render, staticRenderFns } from "./AddRecoveryDialog.vue?vue&type=template&id=4fcb2b80&scoped=true"
import script from "./AddRecoveryDialog.vue?vue&type=script&lang=js"
export * from "./AddRecoveryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb2b80",
  null
  
)

export default component.exports